import React, { useEffect, useState } from "react";
import "../../global.css";
import "./visualNarratives.css";
import { useMediaQuery } from "react-responsive";
import { setContent, setIsOpenContentsModal } from "../../redux/contentSlice";
import { useSelector, useDispatch } from "react-redux";
import { IoReorderThreeOutline } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import ContentCard from "../../components/contentcard/ContentCard";
import { FaArrowRight, FaMinus, FaPlus } from "react-icons/fa";
import VideoPlayer from "../../components/videoplayer/VideoPlayer";
import { useTranslate } from "../../utils/useTranslate";

const VisualNarratives = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const [isShowAll, setIsShowAll] = useState(false);
  const [contentDatas, setContentDatas] = useState([]);

  const openVideoModal = (embedCode) => {
    setVideoUrl(embedCode);
    setIsVideoModalOpen(true);
  };

  const closeVideoModal = () => {
    setIsVideoModalOpen(false);
    setVideoUrl("");
  };

  const [activeItem, setActiveItem] = useState(null);
  const [activeTag, setActiveTag] = useState(null);

  const [contents, setContents] = useState([]);
  const [otherContents, setOtherContents] = useState([]);

  const { language } = useSelector((state) => state.language);

  useEffect(() => {
    if (language.value === "en") {
      fetch("/assets/datas/contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    } else {
      fetch("/assets/datas/tr-contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    }
  }, [language]);

  const { content, isOpenContentsModal } = useSelector(
    (state) => state.content
  );

  useEffect(() => {
    console.log(contents[0]?.datas);
    dispatch(setContent(contents[0]));
    setOtherContents(contents.filter((x) => x.id !== Number(contents[0].id)));
    setContentDatas(contents[0]?.datas);
  }, [contents, dispatch]);

  return (
    <div className="globalContainer visualNarrativesContainer">
      <div
        className="visualNarrativesLeftContainer"
        style={{
          width: isOpenContentsModal === false && isMobile === false && "96%",
        }}
      >
        <div className="visualNarrativesLeftSubContainer">
          <div className="visualNarrativesLeftSubAltContainer">
            <span className="textFlex visualNarrativesTitleStyle">
              {language.value === "tr"
                ? content?.title.toLocaleUpperCase("tr-TR")
                : content?.title.toLocaleUpperCase("en-US")}
            </span>
            <span className="textMono visualNarrativesSubTitleStyle">
              {content?.subTitle}
            </span>
          </div>
          <span className="textFlex visualNarrativesDescriptionStyle">
            {content?.description}
          </span>
        </div>
        {isShowAll === true && (
          <div
            style={{
              width: "100%",
              height: "35px",
              marginTop: "30px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <button
              className="textMono"
              style={{
                padding: "5px 20px",
                backgroundColor: "#ef4536",
                fontWeight: "bold",
                borderRadius: "6px",
                cursor: "pointer",
              }}
              onClick={() => {
                setContentDatas(content?.datas);
                setIsShowAll(false);
              }}
            >
              {language.value === "tr"
                ? translate("showAll").toLocaleUpperCase("tr-TR")
                : translate("showAll").toLocaleUpperCase("en-US")}
            </button>
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
            gap: isMobile === false ? "60px" : "30px",
            marginTop: "40px",
          }}
        >
          {contentDatas?.map((tag) => (
            <div
              key={tag.id}
              style={{
                width: "100%",
                height:
                  activeTag?.id !== tag.id && isMobile === false && "250px",
              }}
            >
              <div
                key={tag.id}
                style={{
                  width: "100%",
                  height: isMobile === false && "250px",
                  backgroundColor: "black",
                  borderRadius: "8px",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    backgroundColor: "black",
                    borderRadius: "8px",
                    borderBottomLeftRadius:
                      activeTag?.id === tag.id && tag?.tagDatas === undefined
                        ? "0px"
                        : "8px",
                    borderBottomRightRadius:
                      activeTag?.id === tag.id && tag?.tagDatas === undefined
                        ? "0px"
                        : "8px",
                  }}
                >
                  <img
                    style={{
                      cursor: "pointer",
                    }}
                    className="visualNarrativesLeftImage"
                    alt=""
                    src={`/assets/images/${tag?.tagImage}`}
                    onClick={() =>
                      setActiveTag(tag.id === activeTag?.id ? null : tag)
                    }
                  />
                </div>
                <div
                  style={{
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    width: "90%",
                    height: "72px",
                    bottom: isMobile === false ? "20px" : "10px",
                    gap: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    setActiveTag(tag.id === activeTag?.id ? null : tag)
                  }
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        className="textFlex"
                        style={{
                          color:
                            activeTag?.id === tag.id ? "#EF4536" : "#F2EDED",
                          fontSize: isMobile === false ? "40px" : "20px",
                          fontWeight: "600px",
                          textShadow:
                            "1px 1px 0px black, -1px -1px 0px black, 1px -1px 0px black, -1px 1px 0px black",
                        }}
                      >
                        {language.value === "tr"
                          ? tag?.tagName.toLocaleUpperCase("tr-TR")
                          : tag?.tagName.toLocaleUpperCase("en-US")}
                      </span>
                      <button
                        style={{
                          backgroundColor:
                            tag?.tagColor === undefined
                              ? "#fffff"
                              : `${tag?.tagColor}`,
                          display: "inline-block",
                          borderRadius: "3px",
                          padding: "2px 4px",
                          border: "1px solid #100F0D",
                          width: "fit-content",
                          maxWidth: "100%",
                          cursor: "pointer",
                        }}
                      >
                        <span
                          className="textMono"
                          style={{
                            fontSize: "12px",
                            color: "#100F0D",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                          }}
                        >
                          {language.value === "tr"
                            ? tag?.type.toLocaleUpperCase("tr-TR")
                            : tag?.type.toLocaleUpperCase("en-US")}
                        </span>
                      </button>
                    </div>
                    {activeTag?.id === tag.id ? (
                      <FaMinus
                        style={{
                          color: "#EF4536",
                          fontSize: "32px",
                          cursor: "pointer",
                          filter:
                            "drop-shadow(0 0 1px black) drop-shadow(0 0 1px black) drop-shadow(0 0 1px black)",
                        }}
                        onClick={() =>
                          setActiveTag(tag.id === activeTag?.id ? null : tag)
                        }
                      />
                    ) : (
                      <FaPlus
                        style={{
                          color: "#F2EDED",
                          fontSize: "32px",
                          cursor: "pointer",
                          filter:
                            "drop-shadow(0 0 1px black) drop-shadow(0 0 1px black) drop-shadow(0 0 1px black)",
                        }}
                        onClick={() =>
                          setActiveTag(tag.id === activeTag?.id ? null : tag)
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: tag?.tagDatas === undefined ? "block" : "grid",
                  gridTemplateColumns:
                    isMobile === false ? "repeat(2, 1fr)" : "repeat(1, 1fr)",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: isMobile === false ? "20px" : "0px",
                  marginTop: tag?.tagDatas !== undefined && "20px",
                }}
              >
                {activeTag?.id === tag.id && tag.tagDatas !== undefined
                  ? tag.tagDatas?.map((item) => (
                      <div
                        style={{
                          padding: "10px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                        key={item.id}
                      >
                        <div
                          key={tag.id}
                          style={{
                            width: "100%",
                            height: isMobile === false ? "150px" : "100px",
                            backgroundColor:
                              activeItem?.id === item.id && "black",
                            // borderRadius: "8px",
                            borderTopRightRadius: "8px",
                            borderTopLeftRadius: "8px",
                            position: "relative",
                            display: "flex",
                            justifyContent: "center",
                            // border: "1px solid black",
                          }}
                        >
                          <img
                            style={{
                              cursor: "pointer",
                              width: "100%",
                              height: isMobile === false ? "150px" : "100px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                            alt=""
                            src={`/assets/images/${item?.image}`}
                            onClick={() =>
                              setActiveItem(
                                item.id === activeItem?.id ? null : item
                              )
                            }
                          />
                          <div
                            style={{
                              position: "absolute",
                              display: "flex",
                              flexDirection: "column",
                              width: "90%",
                              height: "20px",
                              bottom: "30px",
                              gap: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              setActiveItem(
                                item.id === activeItem?.id ? null : item
                              )
                            }
                          >
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <span
                                  className="textFlex"
                                  style={{
                                    color:
                                      activeItem?.id === item.id
                                        ? "#EF4536"
                                        : "#F2EDED",
                                    fontSize: "20px",
                                    fontWeight: "600px",
                                    textShadow:
                                      "1px 1px 0px black, -1px -1px 0px black, 1px -1px 0px black, -1px 1px 0px black",
                                  }}
                                >
                                  {language.value === "tr"
                                    ? item?.title.toLocaleUpperCase("tr-TR")
                                    : item?.title.toLocaleUpperCase("en-US")}
                                </span>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "row",
                                    gap: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor:
                                        tag?.tagColor === undefined
                                          ? "#fffff"
                                          : `${tag?.tagColor}`,
                                      display: "inline-block",
                                      borderRadius: "3px",
                                      padding: "2px 4px",
                                      border: "1px solid #100F0D",
                                      width: "fit-content",
                                      maxWidth: "100%",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <span
                                      className="textMono"
                                      style={{
                                        fontSize: "12px",
                                        color: "#100F0D",
                                        fontWeight: "bold",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {language.value === "tr"
                                        ? item?.type.toLocaleUpperCase("tr-TR")
                                        : item?.type.toLocaleUpperCase("en-US")}
                                    </span>
                                  </button>
                                  <span
                                    className="textMono"
                                    style={{
                                      fontSize: "12px",
                                      color: "#F2EDED",
                                      textShadow:
                                        "1px 1px 0px black, -1px -1px 0px black, 1px -1px 0px black, -1px 1px 0px black",
                                    }}
                                  >
                                    {item?.minute} {translate("mins")}
                                  </span>
                                </div>
                              </div>

                              {activeItem?.id === item.id ? (
                                <FaMinus
                                  style={{
                                    color: "#EF4536",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    filter:
                                      "drop-shadow(0 0 1px black) drop-shadow(0 0 1px black) drop-shadow(0 0 1px black)",
                                  }}
                                  onClick={() =>
                                    setActiveItem(
                                      item.id === activeItem?.id ? null : item
                                    )
                                  }
                                />
                              ) : (
                                <FaPlus
                                  style={{
                                    color: "#F2EDED",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    filter:
                                      "drop-shadow(0 0 1px black) drop-shadow(0 0 1px black) drop-shadow(0 0 1px black)",
                                  }}
                                  onClick={() =>
                                    setActiveItem(
                                      item.id === activeItem?.id ? null : item
                                    )
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        {activeItem?.id === item.id && (
                          <div
                            style={{
                              width: "100%",
                              borderBottomLeftRadius: "8px",
                              borderBottomRightRadius: "8px",
                            }}
                          >
                            <span
                              className="textFlex"
                              style={{
                                fontSize: "16px",
                                backgroundColor: "black",
                                color: "white",
                                display: "flex",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                                paddingTop: "20px",
                                paddingBottom: "10px",
                                borderBottomLeftRadius: "8px",
                                borderBottomRightRadius: "8px",
                              }}
                            >
                              {item?.description}
                            </span>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-around",
                                flexDirection: "row",
                                marginTop: "10px",
                                backgroundColor: "#f2eded",
                              }}
                            >
                              {item?.embedCode !== undefined && (
                                <>
                                  <button
                                    style={{
                                      width: "40%",
                                      height:
                                        isMobile === false ? "40px" : "30px",
                                      backgroundColor: "#100F0D",
                                      borderRadius: "3px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      openVideoModal(item?.embedCode)
                                    }
                                  >
                                    <span
                                      className="textMono"
                                      style={{
                                        color: "#F2F2F2",
                                        fontSize:
                                          isMobile === false ? "16px" : "12px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {language.value === "tr"
                                        ? translate(
                                            "watchNow"
                                          ).toLocaleUpperCase("tr-TR")
                                        : translate(
                                            "watchNow"
                                          ).toLocaleUpperCase("en-US")}
                                    </span>
                                  </button>
                                </>
                              )}
                              {item?.detailsUrl !== undefined && (
                                <>
                                  <button
                                    style={{
                                      width: "40%",
                                      height:
                                        isMobile === false ? "40px" : "30px",
                                      backgroundColor: "#F2F2F2",
                                      borderRadius: "3px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      window.open(
                                        item.detailsUrl,
                                        "_blank",
                                        "noopener,noreferrer"
                                      );
                                    }}
                                  >
                                    <span
                                      className="textMono"
                                      style={{
                                        color: "#100F0D",
                                        fontSize:
                                          isMobile === false ? "16px" : "12px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {language.value === "tr"
                                        ? translate(
                                            "goDetails"
                                          ).toLocaleUpperCase("tr-TR")
                                        : translate(
                                            "goDetails"
                                          ).toLocaleUpperCase("en-US")}
                                    </span>
                                    <FaArrowRight
                                      style={{ width: "14px", height: "14px" }}
                                    />
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  : tag?.tagDatas === undefined &&
                    activeTag?.id === tag?.id && (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <span
                            className="textFlex"
                            style={{
                              fontSize: "16px",
                              backgroundColor: "black",
                              color: "white",
                              display: "flex",
                              paddingLeft: "20px",
                              paddingRight: "20px",
                              paddingTop: "20px",
                              paddingBottom: "10px",
                              borderBottomLeftRadius: "8px",
                              borderBottomRightRadius: "8px",
                            }}
                          >
                            {tag?.description}
                          </span>
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-around",
                            flexDirection: "row",
                            backgroundColor: "#f2eded",
                            paddingTop: "20px",
                          }}
                        >
                          {tag?.embedCode !== undefined && (
                            <>
                              <button
                                style={{
                                  width: "40%",
                                  height: isMobile === false ? "40px" : "30px",
                                  backgroundColor: "#100F0D",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                }}
                                onClick={() => openVideoModal(tag?.embedCode)}
                              >
                                <span
                                  className="textMono"
                                  style={{
                                    color: "#F2F2F2",
                                    fontSize:
                                      isMobile === false ? "16px" : "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {language.value === "tr"
                                    ? translate("watchNow").toLocaleUpperCase(
                                        "tr-TR"
                                      )
                                    : translate("watchNow").toLocaleUpperCase(
                                        "en-US"
                                      )}
                                </span>
                              </button>
                            </>
                          )}
                          {tag?.detailsUrl !== undefined && (
                            <>
                              <button
                                style={{
                                  width: "40%",
                                  height: isMobile === false ? "40px" : "30px",
                                  backgroundColor: "#F2F2F2",
                                  borderRadius: "3px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "5px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  window.open(
                                    tag.detailsUrl,
                                    "_blank",
                                    "noopener,noreferrer"
                                  );
                                }}
                              >
                                <span
                                  className="textMono"
                                  style={{
                                    color: "#100F0D",
                                    fontSize:
                                      isMobile === false ? "16px" : "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {language.value === "tr"
                                    ? translate("goDetails").toLocaleUpperCase(
                                        "tr-TR"
                                      )
                                    : translate("goDetails").toLocaleUpperCase(
                                        "en-US"
                                      )}
                                </span>
                                <FaArrowRight
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {isOpenContentsModal === true && isMobile === false ? (
        <div className="visualNarrativesRightContainer">
          <div className="visualNarrativesRightSubContainer">
            <span className="textMono otherContentTextStyle">
              {language.value === "tr"
                ? translate("otherContents").toLocaleUpperCase("tr-TR")
                : translate("otherContents").toLocaleUpperCase("en-US")}
            </span>
            <hr className="visualNarrativesRightDivHr" />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              gap: "10px",
            }}
          >
            {otherContents.map((item) => (
              <ContentCard
                item={item}
                isHome={false}
                isMobile={false}
                key={item.id}
              />
            ))}
          </div>
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("otherContents").toLocaleUpperCase("tr-TR")
                  : translate("otherContents").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : isMobile === true && isOpenContentsModal === false ? (
        <div className="homeRightContainer">
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
              onClick={() => dispatch(setIsOpenContentsModal(true))}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("otherContents").toLocaleUpperCase("tr-TR")
                  : translate("otherContents").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : (
        isMobile === true &&
        isOpenContentsModal === true && (
          <div className="customModalOverlay">
            <div className="customModalContainer">
              <div
                className="homeRightContainer"
                style={{
                  height: "70vh",
                }}
              >
                <div className="homeRightSubContainer">
                  <span className="textMono allContentTextStyle">
                    {language.value === "tr"
                      ? translate("otherContents").toLocaleUpperCase("tr-TR")
                      : translate("otherContents").toLocaleUpperCase("en-US")}
                  </span>
                  <hr className="homeRightDivHr" />
                </div>
                <div className="modalScrollableContent">
                  {otherContents.map((item) => (
                    <ContentCard
                      item={item}
                      key={item.id}
                      isHome={false}
                      isMobile={true}
                    />
                  ))}
                </div>

                {isMobile && (
                  <button
                    className="allContentMobileStyle"
                    style={{ textDecoration: "none" }}
                    onClick={() => dispatch(setIsOpenContentsModal(false))}
                  >
                    <IoCloseOutline
                      style={{ fontSize: "18px", color: "#100F0D" }}
                    />
                    <span className="linkTextStyle textMono">
                      {language.value === "tr"
                        ? translate("otherContents").toLocaleUpperCase("tr-TR")
                        : translate("otherContents").toLocaleUpperCase("en-US")}
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        )
      )}
      {isVideoModalOpen && (
        <div className="video-modal-overlay">
          <div className="video-modal-container">
            <IoClose
              onClick={closeVideoModal}
              style={{
                fontSize: "18px",
                color: "#100F0D",
                cursor: "pointer",
              }}
            />
            <VideoPlayer embedCode={videoUrl} />
          </div>
        </div>
      )}
    </div>
  );
};

export default VisualNarratives;
